// How each land gets built. A land with a manifest (public/models/lands/<id>/land.json) is a MODEL LAND — built from real art the same
// way Capital City is (scene/modelLand.js). A land without one gets the plain placeholder. To give a land its own special builder
// (its own deals, weather, enemies…), add it to CustomBuilders: same shape as the others — async (def, progress) → { root, spawn, walk, tick }.
import { fetchLandManifest, buildModelLand } from '../modelLand.js'
import { buildPlaceholderLand } from './placeholder.js'
import { buildKingdomView } from '../kingdomView.js'
import { stayApi } from '../../game/accountManager.js'

const CustomBuilders = {
  // meditation_mountain: (def, progress, ctx) => ...,
  // A guest's visit: the host's real kingdom, read-only (a plain meadow if it cannot be fetched, so the visit and the coffer still work).
  guest_estate: async (def, progress, ctx = {}) => {
    if (ctx.stayId) {
      try { const r = await stayApi.kingdom(ctx.stayId); return await buildKingdomView(r.kingdom, progress) } catch (err) { console.warn('[visit] the host\'s kingdom could not be shown, using the meadow:', err?.message || err) }
    }
    const meadow = await buildPlaceholderLand(def, progress)
    meadow.dispose = () => meadow.root.parent?.remove(meadow.root) // (rebuilt on the next visit, so a kingdom that could not be fetched this time can be next time)
    return meadow
  },
}

export async function buildLand(def, progress, ctx = {}) {
  if (CustomBuilders[def.id]) return CustomBuilders[def.id](def, progress, ctx)
  const manifest = await fetchLandManifest(def.id)
  return manifest ? buildModelLand(def, manifest, progress) : buildPlaceholderLand(def, progress)
}
